/**
 * FastSTO — Estocástico Rápido.
 *
 * Migrado do Silverlight (GraficoDePrata/Formulas/FMLMomentum.cs, classe
 * FML.FastSTO). Painel próprio, 2 linhas, escala 0–100:
 *
 *   K = (C − LLV(L,N)) / (HHV(H,N) − LLV(L,N)) * 100
 *   D = MA(K, M)                                    (média ARITMÉTICA)
 *
 * As linhas de referência Upper/Lower (80/20) do legado viram aparência
 * (ThresholdLineType) no odin — o calculator fica puro (K e D apenas).
 * Paridade provada em __tests__/fastSto.silverlight.test.js (issue #368).
 */
import { hhv, llv, sub, div, mul, ma } from "./silverlightDsl";
import { FastSTO as defaultOptions } from "./defaultOptionsForComputation";

export default function () {
  let options = defaultOptions;

  function calculator(data) {
    const { period, m } = options;
    const num = (v) => (Number.isFinite(v) ? v : NaN);
    const high = data.map((d) => num(d.high));
    const low = data.map((d) => num(d.low));
    const close = data.map((d) => num(d.close));

    const hh = hhv(high, period);
    const ll = llv(low, period);
    const kSeries = mul(div(sub(close, ll), sub(hh, ll)), 100);
    const dSeries = ma(kSeries, m);

    return kSeries.map((v, i) => {
      const k = Number.isFinite(v) ? v : undefined;
      const d = Number.isFinite(dSeries[i]) ? dSeries[i] : undefined;
      if (k === undefined && d === undefined) return undefined;
      return { k, d };
    });
  }

  calculator.undefinedLength = function () {
    const { period, m } = options;
    // K acumula N-1; D acrescenta M-1.
    return Math.max(0, period - 1 + (m - 1));
  };

  calculator.options = function (x) {
    if (!arguments.length) {
      return options;
    }
    options = { ...defaultOptions, ...x };
    return calculator;
  };

  return calculator;
}
